import { getMultipleBrands } from "../controllers/brand-name-field-controller";
import { AgreementScope, Brand, Disease, Generic, Indication } from "../models/generated/graphql";
import { anyNamedEntity } from "./any-named-entity";

export const RACA_FLEX_ENTITY_ID = "RA-0000000001";

export const isScopeMatchedByDrugs = (scope: AgreementScope, brands: Array<Array<Brand>>, generics: Array<Generic>) =>
	!generics.length ||
	(scope.treatmentSets.length >= generics.length &&
		generics.every((generic, index) =>
			scope.treatmentSets.some(
				(treatmentSet) =>
					(!generic || generic.Name === treatmentSet.generic.Name) &&
					(!brands[index].length ||
						brands[index]?.[0].Name === anyNamedEntity.Name ||
						treatmentSet.preparations.length === 0 ||
						treatmentSet.preparations.some((preparation) =>
							brands[index]?.some((brands) => brands.Name === preparation.BrandName)
						))
			)
		));

export const isScopeExactlyMatchedByDrugs = (scope: AgreementScope, brands: Array<Array<Brand>>, generics: Array<Generic>) =>
	!generics.length ||
	(scope.treatmentSets.length >= generics.length &&
		generics.every((generic, index) =>
			scope.treatmentSets.some(
				(treatmentSet) =>
					(!generic || generic.Name === treatmentSet.generic.Name) &&
					(!brands[index].length ||
						brands[index]?.[0].Name === anyNamedEntity.Name ||
						treatmentSet.preparations.length === 0 ||
						treatmentSet.preparations.every((preparation) =>
							brands[index]?.some((brands) => brands.Name === preparation.BrandName)
						))
			)
		));

export const isScopeMatchedByScopeId = (scope: AgreementScope, scopeId: string | null) =>
	!scopeId || isCountryScopeMatched(scope, scopeId) || isOrganizationScopeMatched(scope, scopeId);

export const isScopeMatchedByIndication = (scope: AgreementScope, indication: Indication | null) =>
	!indication ||
	scope.indications.length === 0 ||
	scope.enrollingConditionSets.some((conditionSet) => conditionSet.isIndicationNotEnrollingCondition) ||
	scope.indications.some((scopeIndication) => indication.code === scopeIndication.code);

export const isScopeMatchedByDisease = (scope: AgreementScope, disease: Disease | null) =>
	!disease ||
	scope.diseases.length === 0 ||
	scope.enrollingConditionSets.some((conditionSet) => conditionSet.isDiseaseNotEnrollingCondition) ||
	scope.diseases.some((scopeDisease) => disease.Icd10Code === scopeDisease.Icd10Code);

export const isCountryScopeMatched = (scope: AgreementScope, scopeId: string): boolean =>
	scope.countryScopesConnection.edges.some((countryScope) => countryScope.countryScopeId === scopeId);

export const isOrganizationScopeMatched = (scope: AgreementScope, scopeId: string): boolean =>
	((scope.orgScopes || scope.organizationScopesConnection.edges) ?? []).some(
		(organizationScope) => organizationScope.organizationScopeId === scopeId
	);

export const isNotRestrictedByRACASingleBrandScopeRule = (scope: AgreementScope, flexEntityId: string | null) => {
	if (flexEntityId !== RACA_FLEX_ENTITY_ID) {
		return true;
	}

	const brands = scope.treatmentSets.flatMap((treatmentSet) => getMultipleBrands(treatmentSet));

	return brands.length === 1;
};
